<template>
  <div class="strip_all_tour_list wow fadeIn" data-wow-delay="0.1s"
    style=" position: relative; overflow: hidden; visibility: visible; animation-delay: 0.1s; animation-name: fadeIn;">
    <div v-if="selectedItems.flightNumber === availableFlight.flightNumber" class="ribbon text-center">
      <!-- <p>انتخاب شده</p>  -->
    </div>
    <div
      
      class="row">
      <div class="mb-10 pt-10 col-lg-2 col-md-2">
        <div class="custom-img-list img_list">
          <img class="custom-img" src="/img/zagros.png" alt="Image" />
          <div class="custom-short_info short_info">{{ availableFlight.airLineTitle }}</div>
        </div>
      </div>
      <div class="pt-10 col-lg-8 col-md-8">
        <div class="row custom_tour_list_desc tour_list_desc">
          <div class="location-title mb-10 pt-10 col-2">
            <div class="mb-10">{{ availableFlight.originCity }}</div>
            <div>{{ availableFlight.departureTime }}</div>
          </div>
          <div class="pt-10 col-8">
            <div class="plane-line">
              <div class="plane"></div>
            </div>
          </div>
          <div class="location-title pt-10 col-2">
            <div class="mb-10">{{ availableFlight.destinationCity }}</div>
            <div>{{ availableFlight.arrivalTime }}</div>
          </div>
        </div>
        <div class="flight-time">{{ availableFlight.departureDateTimeShamsiText }} - {{ availableFlight.departureTime }}
        </div>
      </div>
      <div class="pt-10 col-lg-2">
        <div class="custom-price_list price_list">
          <div>
            <div v-if="showPrice">
              <div v-if="availableFlight.totalAdultFare < availableFlight.totalAdultProvideFare">
                <span class="normal_price_list">{{ availableFlight.totalAdultProvideFare | numFormat }}</span>
                <label>{{ availableFlight.totalAdultFare | numFormat }}</label>
              </div>
              <div v-if="availableFlight.totalAdultFare >= availableFlight.totalAdultProvideFare">
                <label>{{ availableFlight.totalAdultFare | numFormat }}</label>
              </div>
            </div>

            <p>
              <button v-if="selectedItems.flightNumber !== availableFlight.flightNumber"
                @click="$emit('selected', availableFlight)" class="btn btn-primary btn-block mt-2">انتخاب</button>
              <label class="selected-label" v-if="selectedItems.flightNumber === availableFlight.flightNumber">انتخاب
                شده</label>
            </p>
            <label fxFlex v-if="availableFlight.remainedCapacity < 5000"
              class="capacity-low">{{ availableFlight.remainedCapacity }}</label>
            <label fxFlex v-if="availableFlight.remainedCapacity > 5000" class="capacity-full">موجود</label>
          </div>
        </div>
      </div>

      <div class="accordion" :class="{ active: open }">
        <button id="selected-detail" v-if="selectedItems.flightNumber === availableFlight.flightNumber"
          @click="toggleAccordionState">
          جزئیات بیشتر
          <div class="arrow-icon">v</div>
        </button>
        <button id="flight-detail" v-if="selectedItems.flightNumber !== availableFlight.flightNumber"
          @click="toggleAccordionState">
          جزئیات بیشتر
          <div class="arrow-icon">v</div>
        </button>
        <div class="accordion-content row">
          <div class="col-4">
            <label>شماره پرواز :</label>
            <span class="detail-color">{{ availableFlight.flightNumber }}</span>
          </div>

          <div class="col-4">
            <label>فرودگاه مبدا :</label>
            <span class="detail-color">{{ availableFlight.origin }}</span>
          </div>

          <div class="col-4">
            <label>فرودگاه مقصد :</label>
            <span class="detail-color">{{ availableFlight.destination }}</span>
          </div>

          <div class="col-4">
            <label>پرواز از ترمینال :</label>
            <span class="detail-color">{{ availableFlight.departureTerminal }}</span>
          </div>

          <div class="col-4">
            <label>پرواز به ترمینال :</label>
            <span class="detail-color">{{ availableFlight.arrivalTerminal }}</span>
          </div>

          <div class="col-4">
            <label>نوع هواپیما :</label>
            <span class="detail-color">{{ availableFlight.airCraft }}</span>
          </div>

          <div class="col-4">
            <label>مقدار بار مجاز :</label>
            <span class="detail-color">{{ availableFlight.maxAllowedCargo }}</span>
          </div>

          <div class="col-4">
            <label>کلاس نرخی :</label>
            <span class="detail-color">{{ availableFlight.rateClass }}</span>
          </div>

          <div class="col-4">
            <label>نوع بلیط :</label>
            <span class="detail-color">{{ availableFlight.ticketType }}</span>
          </div>
          <div v-if="showPrice" class="col-4">
            <label>قیمت بزرگسال :</label>
            <span class="detail-color">{{ availableFlight.totalAdultProvideFare | numFormat }}</span>
          </div>
          <div v-if="showPrice" class="col-4">
            <label>قیمت کودک :</label>
            <span class="detail-color">{{ availableFlight.totalChildProvideFare | numFormat }}</span>
          </div>
          <div v-if="showPrice" class="col-4">
            <label>قیمت نوزاد :</label>
            <span class="detail-color">{{ availableFlight.totalInfantProvideFare | numFormat }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pdk-Flight-Avail",
  props: { availableFlight: Object, selectedFlight: Object, showPrice: Boolean },
  data() {
    return {
      open: false,
      message: "Accordion"
    };
  },
  computed: {
    selectedItems() {
      return this.selectedFlight = this.selectedFlight;
    }
  },
  methods: {
    toggleAccordionState() {
      this.open = !this.open;
    },
    onSelect(event) {
      this.$emit("selected", event);



    }
  }
};
</script>

<style>
.strip_all_tour_list{
padding: 10px 20px 10px 20px !important;
}
.btn-primary, .btn-danger, .btn-warning, .btn-info {
    border-radius: 26px !important;
  padding: 10px !important; 
}
.ribbon {
  position: absolute;
  display: inline-block;

  top: 0.3em;
  right: 0.8em;

  max-width: 5em;

  color: #fff;

  z-index: 1;
}

.ribbon::after {
  position: absolute;
  top: -1.5em;
  right: -6em;
  content: "";

  height: 4em;
  width: 9em;

  transform: rotatez(45deg);

  background-color: #00c3e1;
  z-index: -1;
}

#selected-detail {
  background: #646464;
    border-radius: 8px;
    color: #fff;
}
#flight-detail{

    border-radius: 40px;

}

.selected-label {
      color: #fff;
    font-size: 15px;
    background: #ff7481;
    padding: 7px 15px;
}

.capacity-low {
  text-align: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
  color: #ef004d !important;
  margin-top: 5px;
  font-size: 14px !important;
}

.capacity-full {
  text-align: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
  color: #14953b !important;
  margin-top: 5px;
  font-size: 14px !important;
}

.detail-color {
  color: #00c3e1;
}

/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
} */

.accordion {
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
}

a,
button,
a:focus,
button:focus {
  border: none;
  color: #000000;
  outline: none;
}

button {
  font: inherit;
  padding: 0.75em 2em;
  position: relative;
  width: 100%;
}

button .arrow-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%) rotate(0deg) scaleX(2.5);
  transition: 0.3s all ease-out;
}

.accordion.active button .arrow-icon {
  transform: translateY(-50%) rotate(180deg) scaleX(2.5);
}

.accordion-content {
  height: 0;
  padding: 0;
  overflow: hidden;
  transition: 0.3s all ease;
  padding-left: 30px !important;
  padding-right: 30px !important;
  background: rgb(249 249 249 / 32%);
  /* padding-top: 15px; */

}

.accordion.active .accordion-content {
  height: auto;
  padding: 0.5rem;
}

.custom-img {
  width: auto !important;
  height: auto !important;
  position: relative !important;
  left: 0% !important;
}

.custom-img-list {
  min-height: 100px !important;
  position: initial !important;
  margin-right: 20px;
}

.custom_tour_list_desc {
 padding: 10px 40px !important;
    border-left: none

}

.price_list {
  margin-left: inherit;
  margin-right: auto;
}

.custom-price_list {
  height: 100px;
  padding: 10px 20px 10px 20px !important;
  font-size: 17px;
  color: #008489;
}

@media only screen and (max-width: 750px) {
  .custom-price_list {
    height: auto !important;
  }

  .tour_list_desc {
    padding: 10px 0 0 20px;
    border-right: none;
    border-left: none
  }

}

@media only screen and (max-width: 768px) {
  .tour_list_desc {
/* padding: 10px 40px !important; */
    border-left: none
  }
}

@media all and (device-width: 1280px) and (device-height: 800px) {
.strip_all_tour_list.wow.fadeIn {
    padding: 30px !important;
}
}

.pt-10 {
  padding: 10px 0px 0px 0px;
}

.location-title {
  padding: 0px;
  font-size: 16px;
}

.mb-10 {
  margin-bottom: 10px;
}

.custom-short_info {
  margin-right: 9px;
  padding: 5px 5px 5px 5px;
  text-align: center !important;
  min-height: 38px;
  background: none;
  color: #2c3e50;
  bottom: auto;
}

.plane {
  transform: rotate(180deg);
  rotate: 180;
  position: absolute;
  width: 30px;
  height: 30px;
  background-position: center center;
  background-size: contain;
  left: 42%;
  animation: plane 5000ms ease-in-out infinite;
  background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCIgdmlld0JveD0iMCAwIDUxMCA1MTAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMCA1MTA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyBpZD0iZmxpZ2h0cyI+CgkJPHBhdGggZD0iTTUxMCwyNTVjMC0yMC40LTE3Ljg1LTM4LjI1LTM4LjI1LTM4LjI1SDMzMS41TDIwNCwxMi43NWgtNTFsNjMuNzUsMjA0SDc2LjVsLTM4LjI1LTUxSDBMMjUuNSwyNTVMMCwzNDQuMjVoMzguMjUgICAgbDM4LjI1LTUxaDE0MC4yNWwtNjMuNzUsMjA0aDUxbDEyNy41LTIwNGgxNDAuMjVDNDkyLjE1LDI5My4yNSw1MTAsMjc1LjQsNTEwLDI1NXoiIGZpbGw9IiM1MjUwNTIiLz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K);
}

.plane-line::before {
  border: 1px dashed black;
}

.flight-time {
  text-align: center;
  font-size: 15px;
}

@keyframes plane {
  0% {
    right: 39%;
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    right: 58%;
    opacity: 0;
  }
}
</style>


